import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';
interface HeroProps {
  onRequestReview: () => void;
}
export function Hero({
  onRequestReview
}: HeroProps) {
  return <div className="relative min-h-screen flex items-center justify-center bg-charcoal-900 pt-20 overflow-hidden" data-id="element-196">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-197">
        <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Executive Boardroom" className="w-full h-full object-cover opacity-20" data-id="element-198" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal-900/85 via-navy-900/85 to-charcoal-900" data-id="element-199"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-200">
        <div className="animate-fade-in-up" data-id="element-201">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-6 block" data-id="element-202">
            Premium Executive Branding
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif-display font-bold text-white leading-tight mb-6 max-w-5xl mx-auto" data-id="element-203">
            Board & Executive Resume Writing for{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-300" data-id="element-204">
              Leaders Who Shape the Future
            </span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto font-light leading-relaxed mb-10" data-id="element-205">
            Helping Board Directors, Chairpersons, CEOs, Presidents, Advisors,
            and C-Suite Executives position themselves for board appointments,
            executive opportunities, and leadership visibility.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8" data-id="element-206">
            <a href="#contact" className="w-full sm:w-auto bg-gold hover:bg-gold-600 text-navy-900 px-8 py-4 rounded-sm font-semibold text-lg transition-all duration-300 flex items-center justify-center group" data-id="element-207">
              Schedule Consultation
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-208" />
            </a>
            <button type="button" onClick={onRequestReview} className="w-full sm:w-auto bg-transparent border border-gray-400 hover:border-white text-white px-8 py-4 rounded-sm font-semibold text-lg transition-all duration-300 flex items-center justify-center group" data-id="element-209">
              <FileText className="w-5 h-5 mr-2 text-gray-400 group-hover:text-white transition-colors" data-id="element-210" />
              Request Resume Review
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce" data-id="element-211">
        <a href="#about" className="text-gray-400 hover:text-gold transition-colors" data-id="element-212">
          <div className="w-[30px] h-[50px] border-2 border-current rounded-full flex justify-center p-2" data-id="element-213">
            <div className="w-1 h-3 bg-current rounded-full" data-id="element-214"></div>
          </div>
        </a>
      </div>
    </div>;
}